import { render, staticRenderFns } from "./time-item.vue?vue&type=template&id=8394ca3c"
import script from "./time-item.vue?vue&type=script&lang=js"
export * from "./time-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports